import { Component, OnDestroy, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { SettingsUserDetailComponent } from '../settings-user-detail/settings-user-detail.component';
import { takeWhile } from 'rxjs/operators';
import { ResourceUser } from '../../domain/model/resource-user';
import { ResourceUserService } from '../../service/settings/resource-user.service';

@Component({
    selector: 'tnb-settings-users',
    templateUrl: './settings-users-page.component.html',
    styleUrls: [
        './settings-users-page.component.scss',
    ],
    standalone: false,
})
export class SettingsUsersPageComponent implements OnInit, OnDestroy {
    private userService = inject(ResourceUserService);
    private router = inject(Router);
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    private componentDestroyed = false;
    public userList: MatTableDataSource<ResourceUser> = new MatTableDataSource<ResourceUser>();

    public columnsToDisplay = [
        'username',
        'enabled',
        'allowRead',
        'allowWrite',
    ];

    ngOnInit() {
        this.loadUsers();

        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.loadUsers();
            });
    }

    ngOnDestroy() {
        this.componentDestroyed = true;
    }

    createUser() {
        this.router.navigate([],
            {
                queryParams: { username: '' },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsUserDetailComponent);
    }

    openUser(user) {
        this.router.navigate([],
            {
                queryParams: { username: user.username },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsUserDetailComponent);
    }

    private loadUsers() {
        this.userService.getUsers().subscribe(users => {
            this.userList.data = users;
            this.changeDetectorRef.markForCheck();
        });
    }
}
